<a class="__link" [routerLink]="link" href fxLayoutGap=".2rem" *ngIf="!isExternal">
  <ng-content></ng-content>
</a>

<a class="__link" [href]="link" fxLayoutGap=".2rem" *ngIf="isExternal">
  {{overrideText}}
</a>
